// extracted by mini-css-extract-plugin
export var createdDate = "_k2-1";
export var divider = "_k2-2";
export var headerDivider = "_k2-3";
export var messagesCard = "_k2-0";
export var messagesContainer = "_k2-6";
export var messagesContainerWrapper = "_k2-4";
export var showLeftPanelButton = "_k2-8";
export var topButtons = "_k2-7";
export var withPadding = "_k2-5";